module.exports = __webpack_public_path__ + "img/3_factorie.3eaff3a5.jpg";